// "use client"
"use client";
import Footer from '@/components/CommonComponent/footer';
import Header from '@/components/CommonComponent/header';
import Navbar from '@/components/CommonComponent/navbar';
import React, { useState, useRef, useEffect } from 'react';
import { Form, Input, Checkbox, Select, message } from "antd";
import { BASE_URL } from '@/util/api';
import Button from '@/components/CommonComponent/button'
import { useRouter } from 'next/navigation'
const { Option } = Select
declare global {
  interface Window {
    grecaptcha: any;
  }
}
const Contact = () => {
  const formRef = useRef<any>(null);
  const router = useRouter()

  // Load the reCAPTCHA script dynamically on mount
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=6Ld9Q7kqAAAAACUZQAsyTE39c4sKSsf66u5um8MX`;
    script.async = true;
    script.onload = () => {
      // console.log("reCAPTCHA script loaded successfully");
    };
    script.onerror = () => {
      message.error("Failed to load reCAPTCHA script. Please refresh the page.");
    };
    document.body.appendChild(script);
  }, []);

  // Handle form submission
  const handleSubmit = async (values: any) => {
    if (!window.grecaptcha) {
      message.error("reCAPTCHA failed to load. Please refresh the page.");
      return;
    }
    try {
      // Request a reCAPTCHA v3 token
      const token = await window.grecaptcha.execute("6Ld9Q7kqAAAAACUZQAsyTE39c4sKSsf66u5um8MX", { action: "submit" });
      const fullPhoneNumber = `${values.phoneCode}${values.phoneNumber}`

      // Transform checkbox values into a single string for select_services
      const selectedServices = Object.entries(values)
        .filter(([key, value]) => key.startsWith('service_') && value === true)
        .map(([key]) => key.replace('service_', ''))
        .join(';');
          // console.log('data is ',values)

      const response = await fetch(
        "https://api.hsforms.com/submissions/v3/integration/submit/20095080/7b540091-e853-46ae-9e7e-a89a6f91230f",
        {
          method: "POST",
          
          headers: {
            "Content-Type": "application/json",
          },
         
          body: JSON.stringify({
            fields: [
              { name: "firstname", value: values.firstname },
              { name: "lastname", value: values.lastname },
              { name: "email", value: values.email },
              { name: "phone", value: fullPhoneNumber },
              // { name: "phone", value:values.phoneNumber },
              { name: "select_services", value: selectedServices },
              { name: "monthly_spent_budget_for_digital_marketing", value: values.monthly_spent_budget_for_digital_marketing },
              { name: "0-2/facebook_company_page", value: values.social_media_profiles },
              { name: "0-2/website", value: values.website },
              { name: "message", value: values.message },
              { name: "recaptcha_token", value: token },  // Send the reCAPTCHA v3 token
            ],
          }),
        }
      );
      if (response.ok) {
        message.success("Form submitted successfully!");
        formRef.current.resetFields();
        router.push('/thank-you');

      } else {
        const errorData = await response.json();
        // //console.error("Error submitting form:", errorData);
        message.error("Failed to submit form. Please try again.");
      }
    } catch (error) {
      // //console.error("Error submitting form:", error);
      message.error("An unexpected error occurred. Please try again.");
    }
  };
  const countryData = [
    { name: "India", code: "+91" },
    { name: "United States", code: "+1" },
    { name: "United Kingdom", code: "+44" },
    { name: "Canada", code: "+1" },
    { name: "Australia", code: "+61" },
    { name: "Germany", code: "+49" },
    { name: "France", code: "+33" },
    { name: "China", code: "+86" },
    { name: "Japan", code: "+81" },
    { name: "Brazil", code: "+55" },
    { name: "Mexico", code: "+52" },
    { name: "South Africa", code: "+27" },
    { name: "Russia", code: "+7" },
    { name: "Italy", code: "+39" },
    { name: "Spain", code: "+34" },
    { name: "Netherlands", code: "+31" },
    { name: "Sweden", code: "+46" },
    { name: "Switzerland", code: "+41" },
    { name: "United Arab Emirates", code: "+971" },
    { name: "Saudi Arabia", code: "+966" },
    { name: "South Korea", code: "+82" },
    { name: "New Zealand", code: "+64" },
    { name: "Malaysia", code: "+60" },
    { name: "Singapore", code: "+65" },
  ];
  return (
    <div>
      <Header />
      <Navbar />
      <div className="w-full bg-no-repeat bg-[url('/images/contactbanner.png')]">
        <h1 className="text-[32px] lg:text-[44px] text-center pt-12 font-bold text-white">Get a Free Strategy Review</h1>
        <div className="mx-auto xl:w-[95%] 2xl:w-[75%] px-4 py-24 flex flex-wrap md:flex-nowrap justify-center gap-8 items-start">
          <div className="w-full  bg-white p-8 xl:w-[95%] 2xl:w-[75%] shadow-xl rounded-2xl ">
            <Form
              ref={formRef}
              layout="vertical"
              onFinish={handleSubmit}
              className=" mx-auto"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Form.Item name="firstname" label="First Name" rules={[{ required: true, message: "Please enter your first name!" }]} >
                  <Input placeholder="E.g., John" />
                </Form.Item>
                <Form.Item name="lastname" label="Last Name" rules={[{ required: true, message: "Please enter your last name!" }]} >
                  <Input placeholder="E.g., Doe" />
                </Form.Item>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Form.Item name="email" label="Email Address" rules={[{ required: true, type: "email", message: "Please enter a valid email!" }]} >
                <Input placeholder="E.g., john@doe.com" />
              </Form.Item>
              <Form.Item name="monthly_spent_budget_for_digital_marketing" label="Monthly Spent Budget for Digital Marketing" rules={[{ required: true, message: "Please enter your budget!" }]} >
                <Input placeholder="E.g., $250" />
              </Form.Item>
              </div>
              <Form.Item label="Phone Number" required>
                <div className="grid grid-cols-3 gap-2">
                  <Form.Item name="phoneCode" noStyle rules={[{ required: true, message: "Required" }]}> 
                    <Select placeholder="Code">
                      {countryData.map((country) => (
                        <Option key={country.code} value={country.code}>{country.name} ({country.code})</Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item name="phoneNumber" noStyle rules={[{ required: true, message: "Enter phone number!" }, { pattern: /^[0-9]{10,15}$/, message: "Phone number must be between 10 and 15 digits!" }]}> 
                    <Input placeholder="Enter phone number" maxLength={15} />
                  </Form.Item>
                </div>
              </Form.Item>
          
              <Form.Item label="Select Our Services" required>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  <Form.Item name="service_Search_Engine_Optimization" valuePropName="checked" noStyle>
                    <Checkbox>Search Engine Optimization</Checkbox>
                  </Form.Item>
                  <Form.Item name="service_Google_Ads" valuePropName="checked" noStyle>
                    <Checkbox>Google Ads</Checkbox>
                  </Form.Item>
                  <Form.Item name="service_Yahoo_Ads" valuePropName="checked" noStyle>
                    <Checkbox>Yahoo Ads</Checkbox>
                  </Form.Item>
                  <Form.Item name="service_Facebook_Ads" valuePropName="checked" noStyle>
                    <Checkbox>Facebook Ads</Checkbox>
                  </Form.Item>
                  <Form.Item name="service_LinkedIn_Marketing" valuePropName="checked" noStyle>
                    <Checkbox>LinkedIn Marketing</Checkbox>
                  </Form.Item>
                  <Form.Item name="service_Instagram_Growth_Marketing" valuePropName="checked" noStyle>
                    <Checkbox>Instagram Growth Marketing</Checkbox>
                  </Form.Item>
                  <Form.Item name="service_Twitter_Marketing" valuePropName="checked" noStyle>
                    <Checkbox>Twitter Marketing</Checkbox>
                  </Form.Item>
                  <Form.Item name="service_Pinterest_Marketing" valuePropName="checked" noStyle>
                    <Checkbox>Pinterest Marketing</Checkbox>
                  </Form.Item>
                  <Form.Item name="service_Website_Development" valuePropName="checked" noStyle>
                    <Checkbox>Website Development</Checkbox>
                  </Form.Item>
                  <Form.Item name="service_Content_Writing" valuePropName="checked" noStyle>
                    <Checkbox>Content Writing</Checkbox>
                  </Form.Item>
                  <Form.Item name="service_Backlinks_Creation" valuePropName="checked" noStyle>
                    <Checkbox>Backlinks Creation</Checkbox>
                  </Form.Item>
                  <Form.Item name="service_YouTube_Marketing" valuePropName="checked" noStyle>
                    <Checkbox>YouTube Marketing</Checkbox>
                  </Form.Item>
                  <Form.Item name="service_GMB_Listing_Optimization" valuePropName="checked" noStyle>
                    <Checkbox>GMB Listing & Optimization</Checkbox>
                  </Form.Item>
                </div>
              </Form.Item>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Form.Item name="social_media_profiles" label="Social Media Profiles" rules={[{ required: true, message: "Please enter your Social Media Profile" }]}>
                  <Input placeholder="Enter your social media profiles" />
                </Form.Item>
                <Form.Item name="website" label="Website URL" rules={[{ required: true, message: "Please enter your Website Url!" }]}>
                  <Input placeholder="Enter your website URL" />
                </Form.Item>
              </div>
              <Form.Item name="message" label="Message" rules={[{ required: true, message: "Please enter message!" }]}>
                <Input.TextArea placeholder="Enter your message" rows={4} />
              </Form.Item>
              {/* No visible reCAPTCHA needed for v3 */}
              <Form.Item className="mt-4">
                <Button type="primary" htmlType="submit" className="bg-red-500 hover:bg-red-600" content='Request Quote'/>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;

{/* <HubspotForm  portalId="20095080" formId={"7b540091-e853-46ae-9e7e-a89a6f91230f"} region={'na1'}/> */ }